(function () {
  function initialise(scope) {
    if (typeof window.Swiper !== 'function') return;
    scope.querySelectorAll('.shop-detail__gallery').forEach(function (gallery) {
      if (gallery.swiper) { gallery.swiper.update(); return; }
      new window.Swiper(gallery, {
        slidesPerView: 1,
        watchOverflow: true,
        navigation: { nextEl: gallery.querySelector('.swiper-button-next'), prevEl: gallery.querySelector('.swiper-button-prev') },
        pagination: {
          el: gallery.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet: function (index, className) {
            return '<button type="button" class="' + className + '" aria-label="Show product image ' + (index + 1) + '"></button>';
          }
        },
        hashNavigation: { watchState: true }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else { initialise(document); }
  window.addEventListener('load', function () { initialise(document); });
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
}());
